"use client";

import { HallowABFlag } from "@packages/ab";
import type { MixpanelLogicFlag } from "@packages/ab/src/providers/ABProvider";

export const FLAGS: { [key in HallowABFlag]?: MixpanelLogicFlag } = {
  [HallowABFlag.WebHomepageCTADestination]: {
    type: "guest",
    evaluate: ({ geolocation }) => geolocation.country.toUpperCase() === "US",
  },
  [HallowABFlag.WebDOBCollection]: {
    type: "guest",
    evaluate: () => true,
  },
  [HallowABFlag.WebMissionSupporter]: {
    type: "user",
    evaluate: () => true,
  },
  [HallowABFlag.WebRoutines]: {
    type: "user",
    evaluate: () => true,
    kind: "feature",
  },
  [HallowABFlag.WebKidsProfileLaunch]: {
    type: "guest",
    evaluate: () => true,
    kind: "feature",
  },
  [HallowABFlag.WebSSHomepage]: {
    type: "guest",
  },
  [HallowABFlag.WebAdminDashKidsProfile]: {
    type: "user",
    kind: "feature",
  },
};
